import { render, staticRenderFns } from "./HeaderMobileMenu.vue?vue&type=template&id=440f708e"
import script from "./HeaderMobileMenu.vue?vue&type=script&lang=js"
export * from "./HeaderMobileMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseImage: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_073241/resources/assets/marketplace/components/BaseImage.vue').default,BaseLink: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_073241/resources/assets/marketplace/components/BaseLink.vue').default})
